<template>
  <div class="Kadarrespon">
   <v-card style="margin-top: 250px">
   <v-snackbar
       :timeout="snackbar.timeout"
       :color="snackbar.color"
       v-model="snackbar.show"
     >
       {{ snackbar.message }}
     </v-snackbar>
     <v-breadcrumbs :items="item">
       <template v-slot:item="{ item }">
         <v-breadcrumbs-item
           :href="goToRoute(item.href)"
           :disabled="item.disabled"
         >
           {{ item.text }}
         </v-breadcrumbs-item>
       </template>
     </v-breadcrumbs>
     
     <v-card>
       <v-card-title class="text-h5 grey lighten-2">
        {{ $t("kadarrespon") }} 
       </v-card-title>
 
       <v-container>
         <v-form ref="formkadarrespon">
           <v-row>
 
             <v-col cols="12" sm="4">
               <v-autocomplete
                 outlined
                 dense
                 v-bind:label="$t('negeri')"
                 return-object
                 :items="lookupnegeri"
                 :item-text="item => item.negeriID +' - '+ item.negeri"
                  item-value="negeriID"
                 v-model="detailNegeri"
                 :disabled="disablenegeri"
                 v-on:change="paparlookupsample"
               ></v-autocomplete>
             </v-col>
 
             <v-col cols="12" sm="3">
               <v-autocomplete
                 outlined
                 dense
                 v-bind:label="$t('sample')"
                 return-object
                 :items="lookupsample"
                 item-text="sample"
                 v-model="paparsample"
                 :disabled="disablesample"
                 ref="fokuspaparsample"
               ></v-autocomplete>
             </v-col>
 
             <v-col cols="12" sm="3">
               <v-autocomplete
                 outlined
                 dense
                 v-bind:label="$t('pusingan')"
                 return-object
                 :items="lookuppusingan"
                 item-text="pusingan"
                 v-model="paparpusinganexport"
               ></v-autocomplete>
             </v-col>
 
              <v-col class="text-right">
              <v-btn
                     color="blue white white--text"
                     @click="cari()">
                     <span class="material-icons">search</span> 
                    {{ $t("cari") }}</v-btn> 
              </v-col>
             
               <Overlay v-show="showOverlay"/>
 
              <v-col v-show="isShowing" class="text-right">
                   <v-btn type="button" color="red white white--text"  
             @click="downloadPDF('pdf')"><span class='fas fa-file-pdf' style='font-size:24px'></span>
                 {{ $t("muatturun") }} 
            </v-btn>
             &nbsp;&nbsp;
 
              <v-btn type="button" color="green white white--text"
                 @click="downloadExcel('xls')"><span class='fas fa-file-excel' style='font-size:24px'></span>
                 {{ $t("muatturun") }} 
               </v-btn></v-col></v-row>
           </v-form>
    
         <v-card-text>
            
           <v-simple-table fixed-header dense 
             ref="exportable_table" 
               class="table-bordered" id="table1">
             <thead>
              <tr>
                 <th colspan="1" style="text-align: center; border: none;">
                  <img src="https://i.ibb.co/WBrF5yQ/JATANEGARA.png" alt="JataNegara" width="80" height="70">
               </th>
                  <th colspan="12" style="text-align: center; border:none;" class="text-h6">
                    <strong>SISTEM SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS  &nbsp; <br>
                   KADAR RESPON ISI RUMAH</strong>
               </th>
                <th colspan="1" style="text-align: center; border: none;">
                  <img src="https://i.ibb.co/bX8FgBj/HIES.png" alt="HIES/BA" width="80" height="70">
               </th>
               </tr>
               <tr>
                 <th rowspan="2" style="text-align: center">
                   <strong>KATEGORI</strong>
                 </th>
                 <th rowspan="2" style="text-align: center">
                   <strong>JUMLAH TEMPAT KEDIAMAN</strong>
                 </th>
                 <th rowspan="2" style="text-align: center">
                  <strong><br />TEMPAT KEDIAMAN SELESAI <br />(-1-)</strong>
                 </th>
                 <th colspan="7" style="text-align: center">
                   <strong>TIADA SAMBUTAN</strong>
                 </th>
                 <th colspan="2" style="text-align: center">
                   <strong>TIADA SAMBUTAN TSD & EKS</strong>
                 </th>
                 <th rowspan="2" style="text-align: center">
                   <strong>% SELESAI</strong>
                 </th>
                 <th rowspan="2" style="text-align: center">
                   <strong>% SELESAI SELAIN TSD & EKS</strong>
                 </th>
               </tr>
               <tr>
                 <th style="text-align: center">
                   <strong>KOSONG <br />(-2-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>RUMAH DALAM PEMBINAAN <br />(-4-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>BUKAN TEMPAT KEDIAMAN/TK INSTITUSI <br />(-5-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>ROBOH/ USANG <br />(-6-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>TEMPAT&nbsp;LAYAK<br />(-7-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>LAIN-LAIN <br />(-9-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>LAIN-LAIN DIDIAMI <br />(-0-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>TIADA SIAPA DI RUMAH <br />(-3-)</strong>
                 </th>
                 <th style="text-align: center">
                   <strong>ENGGAN KERJASAMA <br />(-8-)</strong>
                 </th>
               </tr>
             </thead>
             <tbody>
                   <tr>
                     <td style="text-align:left;"><strong> {{detailNegeri.negeri}}</strong></td>
                   
                    <td style="text-align:center;">  
                      {{calculateResponTotal()}}
                     </td>
 
                     <td style="text-align:center;">
                       {{calculateRespon('1')}}
                     </td>
 
                     <td style="text-align:center;">
                      {{calculateRespon('2')}}
                     </td>
 
                     <td style="text-align:center;">
                       {{calculateRespon('4')}}
                     </td>
 
                     <td style="text-align:center;">
                        {{calculateRespon('5')}}
                     </td>
 
                     <td style="text-align:center;">
                        {{calculateRespon('6')}}
                     </td>
 
                    <td style="text-align:center;">
                        {{calculateRespon('7')}}
                     </td>
 
                     <td style="text-align:center;">
                       {{calculateRespon('9')}}
                     </td>
 
                     <td style="text-align:center;">
                       {{calculateRespon('0')}}
                     </td>
 
                     <td style="text-align:center;">
                        {{calculateRespon('3')}}
                     </td>
 
                     <td style="text-align:center;">
                        {{calculateRespon('8')}}
                     </td>
 
                     <td style="text-align:center;">
                        {{calculateResponPercentSelesai()}}
                     </td>
 
                      <td style="text-align:center;">
                       {{calculateResponPercentSelesaiSelain()}}
                     </td>
                  </tr>
               
               <tr>
                 <td colspan="14" style="text-align: left">
                   <strong>Strata :</strong>
                 </td>
               </tr>
               <tr>
                 <td style="text-align: left">Bandar</td>
                 
                 <td style="text-align:center;">  
                     {{calculateResponStrataBTotal()}}
                     </td>
 
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('1','1')}}
                    </td>
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('2','1')}}
                    </td>
                  <td style="text-align:center;"> 
                    {{calculateResponStrata('4','1')}}
                    </td>
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('5','1')}}
                    </td>
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('6','1')}}
                    </td>
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('7','1')}}
                    </td>
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('9','1')}}
                    </td>
                  <td style="text-align:center;"> 
                    {{calculateResponStrata('0','1')}}
                    </td>
                  <td style="text-align:center;"> 
                    {{calculateResponStrata('3','1')}}
                    </td>
                 <td style="text-align:center;"> 
                    {{calculateResponStrata('8','1')}}
                    </td>
                 <td style="text-align:center;"> 
                     {{calculateResponPercentBSelesai()}}
                 </td>
                 <td style="text-align:center;"> 
                     {{calculateResponPercentBSelesaiSelain()}}
                 </td>
               </tr>
               <tr>
                 <td style="text-align: left">Luar Bandar</td>
                <td style="text-align: center">
                       {{calculateResponStrataLBTotal()}}
                </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('1','2')}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('2','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('4','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('5','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('6','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('7','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('9','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('0','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('3','2')}}
                      </td>
                   <td style="text-align: center">
                      {{calculateResponStrata('8','2')}}
                      </td>
                   <td style="text-align: center">
                     {{calculateResponPercentLBSelesai()}}
                   </td>
                   <td style="text-align: center">
                     {{calculateResponPercentLBSelesaiSelain()}}
                   </td>
               </tr>
               <tr>
                 <td colspan="14" style="text-align: left">
                   <strong>Daerah Pentadbiran :</strong>
                 </td>
               </tr>
               
                <tr v-for="item in datazDaerah" :key="item.index">
                   <!-- ------loop getlistDaerah----  -->
                    <td style="text-align: left">
                      {{item.NamaDP}}
                   </td>
                   <!-- -------loop getlisDaerah_jumlah ------ -->
                    <td style="text-align: center">
                      {{calculateResponDaerahTotal(item.DP)}}
                    </td>
                   <!-- -------loop getlisDaerah_respon ------ -->
                   <td style="text-align: center">
                      {{calculateResponDaerah1('1',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah2('2',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah3('4',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah4('5',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah5('6',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah6('7',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah7('9',item.DP)}}
                   </td>
                   <td style="text-align: center">
                      {{calculateResponDaerah8('0',item.DP)}}
                   </td>
                   <td style="text-align: center">
                     {{calculateResponDaerah9('3',item.DP)}}
                   </td>
                   <td style="text-align: center">
                     {{calculateResponDaerah10('8',item.DP)}}
                   </td>
                   <td style="text-align: center">
                     {{calculateResponDaerahSelesai()}}
                   </td>
                   <td style="text-align: center">
                     {{calculateResponDaerahSelesaiSelain()}}
                   </td>
               </tr>
             </tbody>
          </v-simple-table>
         </v-card-text>
       </v-container>
     </v-card>
     </v-card>
   </div>
 </template>
 <script>
 import Overlay from '../../components/Overlay'
 import i18n from "@/i18n";
 import axios from "../../plugins/axios";
 import hidServices from "@/services/lookupField";
 const negerilookup = new hidServices();
 import getPusingan from "@/services/pusingan";
 const pusingan = new getPusingan();
 
 export default {
   components: {
   Overlay
 },
   async beforeMount(){
     var res = await pusingan.getPusinganDataAll();
    this.lookuppusingan = res;
 
    this.lookupsample = await pusingan.getSample();
   
 },
 
   Name: "KadarresponOld",
   
   computed: {},
   setup() {},
   
   data: () => ({
       
     snackbar: "",
     showOverlay: false,
     ///////////link untuk ke page/////////////////////
     item: [
       {
         text: i18n.t("utama"),
         disabled: false,
         href: `paparanutama`,
       },
       {
         text: `${i18n.t("kadarrespon")}`,
         disabled: true,
         href: "",
       },
     ],
     title: "",
    
     lookupnegeri: [],
     paparsample: "",
     paparpusinganexport: "",
     lookuppusingan: [],
     lookupsample: [],
     dataKadarRespon:"",
     sortedData: [],
     paparnegeriexport: "",
     disablepusingan: true,
     peranan: "",
     disablenegeri: true,
     disablesample: true,
     dataz: [],
     R:"",
     DP:"",
     detailNegeri:"",
     daerah: "",
     datazDaerah: [],
     isShowing:false,
     
   }),
   async mounted() {
     this.$store.dispatch("localStorageuser");
     this.permulaan();
     
   },
   methods: {
     goToRoute(url) {
       return `/${i18n.locale}/${url}`;
 },
 
     downloadPDF: function () {
          
      var sTable = document.getElementById('table1').innerHTML;

var style = "<style>";
style = style + "body {font: 14px Calibri;}";
style = style + "table {width: 100%; font: 12px Calibri;}";
style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
style = style + "padding: 2px 3px;text-align: center;}";
style = style + "</style>";

// CREATE A WINDOW OBJECT.
var win = window.open( "http://www.domainname.ext/path.png",
                             "DescriptiveWindowName");
win.document.write('<html><head>');
win.document.write('<title>Ringkasan Kadar Respon Isi Rumah</title>');   // <title> FOR PDF HEADER.
win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
win.document.write('</head>');
win.document.write('<body>');

win.document.write('<center>');
win.document.write(`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

win.document.write(`Sample = `+this.paparsample.sample);
win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

win.document.write(`Pusingan = `+this.paparpusinganexport.pusingan);
win.document.write('<br>');
win.document.write('<br>');

win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
win.document.write('</body></html>');

win.document.close(); 	// CLOSE THE CURRENT WINDOW.
win.setTimeout(function () {
win.print();    // PRINT THE CONTENTS.
  }, 100)
},

// downloadExcel: function (type, fn, dl) {

//       var elt = document.getElementById('table1');
//       var wb = XLSX.utils.table_to_book(elt, { sheet: "KadarRespon" });
//       return dl ?

//        XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }):
//        XLSX.writeFile(wb, fn || ('KadarRespon.' + (type || 'xlsx')));

//     },

    

  //    downloadExcel: function () {
  //      var XLSX = require("xlsx");
  //    var elt = document.getElementById('table1');
  //      var fp = XLSX.utils.table_to_book(elt,{sheet:'Sheet1'});
    
  //  XLSX.write(fp,{
  //  	bookType:'xlsx',
  //  	type:'base64'
  //  });
  //  XLSX.writeFile(fp, 'Kadarrespon.xlsx');
  //    },
 
  downloadExcel: function () {
      // format xls
    var uri = 'data:application/vnd.ms-excel;base64,';
  
    var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        })
      }
    var sTable = document.getElementById("table1").innerHTML;
    var ctx = {
      worksheet: 'KadarRespon',
      table: sTable
    };
 
    var style = "<style>";
    style = style + "body {font: 12px Calibri;}";
    style = style + "table {width: 100%; font: 12px Calibri;}";
    style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "</style>";

    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>KadarRespon</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    
    tab_text = tab_text + ('<center>');
    tab_text = tab_text + (`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (`Sample = `+this.paparsample.sample);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    
    tab_text = tab_text + (`Pusingan = `+this.paparpusinganexport.pusingan);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (style); 
    tab_text = tab_text + (sTable);  

    tab_text = tab_text + '</body></html>';
   
    var link = document.createElement("a");
    link.download = "KadarRespon.xls";
    link.href = uri + base64(format(tab_text, ctx))
    link.click();
 
    // window.location.href = uri + window.btoa(tab_text);
  
},


// downloadExcel: function () {
//   var uri = 'data:application/vnd.ms-excel;base64,',
//       template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
//       base64 = function(s) {
//         return window.btoa(unescape(encodeURIComponent(s)))
//       },
//       format = function(s, c) {
//         return s.replace(/{(\w+)}/g, function(m, p) {
//           return c[p];
//         })
//       }
//     var toExcel = document.getElementById("table1").innerHTML;
//     var ctx = {
//       worksheet: 'KadarRespon',
//       table: toExcel
//     };
//     var link = document.createElement("a");
//     link.download = "KadarRespon.xls";
//     link.href = uri + base64(format(template, ctx))
//     link.click();
//   },

// downloadExcel: function () {
// var workbook = XLSX.utils.book_new();
              
//         var worksheet_data  = document.getElementById("table1");
//         var worksheet = XLSX.utils.table_to_sheet(worksheet_data);
        
//         workbook.SheetNames.push("Sheet1");
//         workbook.Sheets["Sheet1"] = worksheet;
      
//          exportExcelFile(workbook);
      
// function exportExcelFile(workbook) {
//     return XLSX.writeFile(workbook, "KadarRespon.xlsx");

//   };
// },

// downloadExcel: function () {
//   var location = 'data:application/vnd.ms-excel;base64,';
// 	var excelTemplate = '<html> ' +
// 		'<head> ' +
// 		'<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
// 		'</head> ' +
// 		'<body> ' +
// 		document.getElementById("table1").innerHTML +
// 		'</body> ' +
// 		'</html>'
// 	window.location.href = location + window.btoa(excelTemplate);
//     },

     async cari() {
         this.isShowing="true"
         this.showOverlay = true;
         this.lookupDaerah()
         
       try {
         const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getRespon?NG=`+this.detailNegeri.negeriID+`&P=`+this.paparpusinganexport.id+`&S=`+this.paparsample.id,{
          
          });
         
          var dataz = res.data.data;
          this.dataKadarRespon = dataz;
          this.sortedData = dataz;
          this.showOverlay = false;
          
       } catch (error) {
         this.errorDialog = true;
         setTimeout(() => (this.errorDialog = false), 2000);
         this.errMessage = "getData : " + error;
       }
 
     },
     
        calculateResponTotal(){
          
          return this.dataKadarRespon.length;
     },
     
        calculateRespon(r){
         
         var totalHID = 0;
 
        for(var i = 0;i < this.sortedData.length ;i++){
           if (r == 1) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon = totalHID
                   }
                 }
                  if (r == 2) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon1 = totalHID
                
                   }
                 }
                  if (r == 4) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon2 = totalHID
                   }
                 }
                if (r == 5) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon3 = totalHID  
                   }
                 }
               if (r == 6) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon4 = totalHID    
                   }
                 }
               if (r == 7) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon5 = totalHID   
                   }
                 }
               if (r == 9) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon6 = totalHID   
                   }
                 }
               if (r == 0) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                 this.CalRespon7 = totalHID    
                   }
                 }
                if (r == 3) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                   this.CalRespon8 = totalHID
                   }
                 }
               if (r == 8) {
               if (this.sortedData[i].R == r){
                 totalHID = totalHID + 1
                   this.CalRespon9 = totalHID
                   }
                 }
         }
         
         return totalHID;
        
     },
 
         calculateResponPercentSelesai(){
        
         var total = 0;
         let respon = 0;
        
           respon = total + Number(this.CalRespon) / Number(this.dataKadarRespon.length) * 100;
           total = Number(respon);
           
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
           },
          
           calculateResponPercentSelesaiSelain(){
         
          var total = 0;
         //  let respon = 0;
          
           var CalRespon = 0;
           var CalRespon1 = 0;
           var CalRespon2 = 0;
           var CalRespon3 = 0;
           var CalRespon4 = 0;
           var CalRespon5 = 0;
           var CalRespon6 = 0;
           var CalRespon7 = 0;
         
             for(var i = 0;i<this.sortedData.length;i++){
             if(this.CalRespon == null){
               this.CalRespon = 0;
             }
              if(this.CalRespon1 == null){
               this.CalRespon1 = 0;
             }
 
              if(this.CalRespon2 == null){
               this.CalRespon2 = 0;
             }
 
              if(this.CalRespon3 == null){
               this.CalRespon3 = 0;
             }
 
              if(this.CalRespon4 == null){
               this.CalRespon4 = 0;
             }
 
              if(this.CalRespon5 == null){
               this.CalRespon5 = 0;
             }
 
              if(this.CalRespon6 == null){
               this.CalRespon6 = 0;
             }
 
              if(this.CalRespon7 == null){
               this.CalRespon7 = 0;
             }
 
           total = total + (Number(this.CalRespon) + Number(this.CalRespon1) + Number(this.CalRespon2) + Number(this.CalRespon3) + Number(this.CalRespon4) + 
           Number(this.CalRespon5) + Number(this.CalRespon6) + Number(this.CalRespon7)) / Number(this.dataKadarRespon.length) * 100;
 
           this.CalRespon = CalRespon;
           this.CalRespon1 = CalRespon1;
           this.CalRespon2 = CalRespon2;
           this.CalRespon3 = CalRespon3;
           this.CalRespon4 = CalRespon4;
           this.CalRespon5 = CalRespon5;
           this.CalRespon6 = CalRespon6;
           this.CalRespon7 = CalRespon7;
 
           total = Number(total);
 
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
             }
           },
 
         calculateResponStrataBTotal(){
 
            var totalHID = 0;
 
         for(var i = 0;i < this.sortedData.length ;i++){
         
               if (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2){
                 totalHID = totalHID + 1
                this.calResponStrataBTotal = totalHID
              
                 }
           }
             return totalHID;
         },
 
 
          calculateResponStrataLBTotal(){
 
         var totalHID = 0;
 
         for(var i = 0;i < this.sortedData.length ;i++){
         
               if (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3){
                 totalHID = totalHID + 1
                this.calResponStrataLBTotal = totalHID
              
                 }
           }
             return totalHID;
         },
 
         calculateResponStrata(r,st){
         
         var totalHID = 0;
 
         for(var i = 0;i < this.sortedData.length ;i++){
           if (r == 1 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                this.CalResponStrata = totalHID
                 }
           }
           if (r == 1 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                this.CalResponStrata1 = totalHID
                 }
           }
            if (r == 2 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                this.CalResponStrata2 = totalHID
                 }
           }
           if (r == 2 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                this.CalResponStrata3 = totalHID
                 }
           }
            if (r == 4 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                 this.CalResponStrata4 = totalHID
                 }
           }
           if (r == 4 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                 this.CalResponStrata5 = totalHID
                 }
           }
            if (r == 5 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                 this.CalResponStrata6 = totalHID
                 }
           }
           if (r == 5 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                 this.CalResponStrata7 = totalHID
                 }
           }
           if (r == 6 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                  this.CalResponStrata8 = totalHID
                 }
           }
           if (r == 6 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                  this.CalResponStrata9 = totalHID
                 }
           }
           if (r == 7 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                 this.CalResponStrata10 = totalHID
                 }
           }
           if (r == 7 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                this.CalResponStrata11 = totalHID
                 }
           }
            if (r == 9 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                this.CalResponStrata12 = totalHID
                 }
           }
           if (r == 9 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                this.CalResponStrata13 = totalHID
                 }
           }
            if (r == 0 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                 this.CalResponStrata14 = totalHID
                 }
           }
           if (r == 0 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                 this.CalResponStrata15 = totalHID
                 }
           }
           if (r == 3 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                 this.CalResponStrata16 = totalHID
                 }
           }
           if (r == 3 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                 this.CalResponStrata17 = totalHID
                 }
           }
           if (r == 8 && st == 1){
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 1 || this.sortedData[i].ST == 2)){
                 totalHID = totalHID + 1
                 this.CalResponStrata18 = totalHID
                 }
           }
           if (r == 8 && st == 2) {
               if (this.sortedData[i].R == r && (this.sortedData[i].ST == 0 || this.sortedData[i].ST >= 3)){
                 totalHID = totalHID + 1
                 this.CalResponStrata19 = totalHID
                 }
           }
         }
         
         return totalHID;
       },
 
        calculateResponPercentBSelesai(){
        
         var total = 0;
         let respon = 0;
        
           respon = total + Number(this.CalResponStrata) / Number(this.calResponStrataBTotal) * 100;
           total = Number(respon);
          
            if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
           },
          
          calculateResponPercentBSelesaiSelain(){
         
          var total = 0;
         //  let respon = 0;
 
           var CalResponStrata = 0;
           var CalResponStrata1 = 0;
           var CalResponStrata2 = 0;
           var CalResponStrata3 = 0;
           var CalResponStrata4 = 0;
           var CalResponStrata5 = 0;
           var CalResponStrata6 = 0;
           var CalResponStrata7 = 0;
           var CalResponStrata8 = 0;
           var CalResponStrata9 = 0;
           var CalResponStrata10 = 0;
           var CalResponStrata11 = 0;
           var CalResponStrata12 = 0;
           var CalResponStrata13 = 0;
           var CalResponStrata14 = 0;
           var CalResponStrata15 = 0;
           var CalResponStrata16 = 0;
           var CalResponStrata17 = 0;
           var CalResponStrata18 = 0;
           var CalResponStrata19 = 0;
 
             for(var i = 0;i<this.sortedData.length;i++){
             if(this.CalResponStrata == null){
               this.CalResponStrata = 0;
             }
              if(this.CalResponStrata1 == null){
               this.CalResponStrata1 = 0;
             }
 
              if(this.CalResponStrata2 == null){
               this.CalResponStrata2 = 0;
             }
 
              if(this.CalResponStrata3 == null){
               this.CalResponStrata3 = 0;
             }
 
              if(this.CalResponStrata4 == null){
               this.CalResponStrata4 = 0;
             }
 
              if(this.CalResponStrata5 == null){
               this.CalResponStrata5 = 0;
             }
 
              if(this.CalResponStrata6 == null){
               this.CalResponStrata6 = 0;
             }
 
              if(this.CalResponStrata7 == null){
               this.CalResponStrata7 = 0;
             }
 
             if(this.CalResponStrata8 == null){
               this.CalResponStrata8 = 0;
             }
              if(this.CalResponStrata9 == null){
               this.CalResponStrata9 = 0;
             }
 
              if(this.CalResponStrata10 == null){
               this.CalResponStrata10 = 0;
             }
 
              if(this.CalResponStrata11 == null){
               this.CalResponStrata11 = 0;
             }
 
              if(this.CalResponStrata12 == null){
               this.CalResponStrata12 = 0;
             }
 
              if(this.CalResponStrata13 == null){
               this.CalResponStrata13 = 0;
             }
 
              if(this.CalResponStrata14 == null){
               this.CalResponStrata14 = 0;
             }
 
              if(this.CalResponStrata15 == null){
               this.CalResponStrata15 = 0;
             }
 
              if(this.CalResponStrata16 == null){
               this.CalResponStrata16 = 0;
             }
 
              if(this.CalResponStrata17 == null){
               this.CalResponStrata17 = 0;
             }
 
              if(this.CalResponStrata18 == null){
               this.CalResponStrata18 = 0;
             }
 
              if(this.CalResponStrata19 == null){
               this.CalResponStrata19 = 0;
             }
 
           total = total + (Number(this.CalResponStrata) + Number(this.CalResponStrata2) + Number(this.CalResponStrata4) + Number(this.CalResponStrata6) + Number(this.CalResponStrata8) + 
           Number(this.CalResponStrata10) + Number(this.CalResponStrata12) + Number(this.CalResponStrata14)) / Number(this.calResponStrataBTotal) * 100;
 
           this.CalResponStrata = CalResponStrata;
           this.CalResponStrata1 = CalResponStrata1;
           this.CalResponStrata2 = CalResponStrata2;
           this.CalResponStrata3 = CalResponStrata3;
           this.CalResponStrata4 = CalResponStrata4;
           this.CalResponStrata5 = CalResponStrata5;
           this.CalResponStrata6 = CalResponStrata6;
           this.CalResponStrata7 = CalResponStrata7;
           this.CalResponStrata8 = CalResponStrata8;
           this.CalResponStrata9 = CalResponStrata9;
           this.CalResponStrata10 = CalResponStrata10;
           this.CalResponStrata11 = CalResponStrata11;
           this.CalResponStrata12 = CalResponStrata12;
           this.CalResponStrata13 = CalResponStrata13;
           this.CalResponStrata14 = CalResponStrata14;
           this.CalResponStrata15 = CalResponStrata15;
           this.CalResponStrata16 = CalResponStrata16;
           this.CalResponStrata17 = CalResponStrata17;
           this.CalResponStrata18 = CalResponStrata18;
           this.CalResponStrata19 = CalResponStrata19;
 
           total = Number(total);
 
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
             }
           },
 
          calculateResponPercentLBSelesai(){
        
         var total = 0;
         let respon = 0;
        
           respon = total + Number(this.CalResponStrata1) / Number(this.calResponStrataLBTotal) * 100;
           total = Number(respon);
           
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
           },
 
           calculateResponPercentLBSelesaiSelain(){
         
          var total = 0;
         //  let respon = 0;
 
           var CalResponStrata = 0;
           var CalResponStrata1 = 0;
           var CalResponStrata2 = 0;
           var CalResponStrata3 = 0;
           var CalResponStrata4 = 0;
           var CalResponStrata5 = 0;
           var CalResponStrata6 = 0;
           var CalResponStrata7 = 0;
           var CalResponStrata8 = 0;
           var CalResponStrata9 = 0;
           var CalResponStrata10 = 0;
           var CalResponStrata11 = 0;
           var CalResponStrata12 = 0;
           var CalResponStrata13 = 0;
           var CalResponStrata14 = 0;
           var CalResponStrata15 = 0;
           var CalResponStrata16 = 0;
           var CalResponStrata17 = 0;
           var CalResponStrata18 = 0;
           var CalResponStrata19 = 0;
          
             for(var i = 0;i<this.sortedData.length;i++){
             if(this.CalResponStrata == null){
               this.CalResponStrata = 0;
             }
              if(this.CalResponStrata1 == null){
               this.CalResponStrata1 = 0;
             }
 
              if(this.CalResponStrata2 == null){
               this.CalResponStrata2 = 0;
             }
 
              if(this.CalResponStrata3 == null){
               this.CalResponStrata3 = 0;
             }
 
              if(this.CalResponStrata4 == null){
               this.CalResponStrata4 = 0;
             }
 
              if(this.CalResponStrata5 == null){
               this.CalResponStrata5 = 0;
             }
 
              if(this.CalResponStrata6 == null){
               this.CalResponStrata6 = 0;
             }
 
              if(this.CalResponStrata7 == null){
               this.CalResponStrata7 = 0;
             }
 
             if(this.CalResponStrata8 == null){
               this.CalResponStrata8 = 0;
             }
              if(this.CalResponStrata9 == null){
               this.CalResponStrata9 = 0;
             }
 
              if(this.CalResponStrata10 == null){
               this.CalResponStrata10 = 0;
             }
 
              if(this.CalResponStrata11 == null){
               this.CalResponStrata11 = 0;
             }
 
              if(this.CalResponStrata12 == null){
               this.CalResponStrata12 = 0;
             }
 
              if(this.CalResponStrata13 == null){
               this.CalResponStrata13 = 0;
             }
 
              if(this.CalResponStrata14 == null){
               this.CalResponStrata14 = 0;
             }
 
              if(this.CalResponStrata15 == null){
               this.CalResponStrata15 = 0;
             }
 
              if(this.CalResponStrata16 == null){
               this.CalResponStrata16 = 0;
             }
 
              if(this.CalResponStrata17 == null){
               this.CalResponStrata17 = 0;
             }
 
              if(this.CalResponStrata18 == null){
               this.CalResponStrata18 = 0;
             }
 
              if(this.CalResponStrata19 == null){
               this.CalResponStrata19 = 0;
             }
 
           total = total + (Number(this.CalResponStrata1) + Number(this.CalResponStrata3) + Number(this.CalResponStrata5) + Number(this.CalResponStrata7) + Number(this.CalResponStrata9) + 
           Number(this.CalResponStrata11) + Number(this.CalResponStrata13) + Number(this.CalResponStrata15)) / Number(this.calResponStrataLBTotal) * 100;
 
           this.CalResponStrata = CalResponStrata;
           this.CalResponStrata1 = CalResponStrata1;
           this.CalResponStrata2 = CalResponStrata2;
           this.CalResponStrata3 = CalResponStrata3;
           this.CalResponStrata4 = CalResponStrata4;
           this.CalResponStrata5 = CalResponStrata5;
           this.CalResponStrata6 = CalResponStrata6;
           this.CalResponStrata7 = CalResponStrata7;
           this.CalResponStrata8 = CalResponStrata8;
           this.CalResponStrata9 = CalResponStrata9;
           this.CalResponStrata10 = CalResponStrata10;
           this.CalResponStrata11 = CalResponStrata11;
           this.CalResponStrata12 = CalResponStrata12;
           this.CalResponStrata13 = CalResponStrata13;
           this.CalResponStrata14 = CalResponStrata14;
           this.CalResponStrata15 = CalResponStrata15;
           this.CalResponStrata16 = CalResponStrata16;
           this.CalResponStrata17 = CalResponStrata17;
           this.CalResponStrata18 = CalResponStrata18;
           this.CalResponStrata19 = CalResponStrata19;
 
           total = Number(total);
 
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
             }
           },
 
        async lookupDaerah() {
       try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getListDaerah?NG=`+this.detailNegeri.negeriID,{ 
         });
       
         this.datazDaerah = res.data.data.listDaerah;
       }
        catch (error) {
         this.errorDialog = true;
         setTimeout(() => (this.errorDialog = false), 2000);
         this.errMessage = "getData : " + error;
       }
     },
     
     calculateResponDaerahTotal(dp){
         
         var totalHID = 0;
 
       for(var i = 0;i < this.sortedData.length ;i++){
 
           if (this.sortedData[i].DP == dp){
             totalHID = totalHID + 1
             this.CalResponDaerahTotal = totalHID
 
             }
       }
         return totalHID;
     },
 
        calculateResponDaerah1(r,dp){
          
          var totalHID1 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
 
            if (r == 1) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID1 = totalHID1 + 1
               this.CalResponDaerah1 = totalHID1
           }
           }
       }
         return totalHID1;
     },
 
       calculateResponDaerah2(r,dp){
          
          var totalHID2 = 0;
 
        
       for(var i = 0;i < this.sortedData.length ;i++){
 
             if (r == 2) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID2 = totalHID2 + 1
               this.CalResponDaerah2 = totalHID2
           }
           }
       }
         return totalHID2;
     },
 
       calculateResponDaerah3(r,dp){
          
          var totalHID3 = 0;
 
       for(var i = 0;i < this.sortedData.length ;i++){
       
             if (r == 4) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID3 = totalHID3 + 1
               this.CalResponDaerah3 = totalHID3
           }
           }
       }
         return totalHID3;
     },
 
      calculateResponDaerah4(r,dp){
          
          var totalHID4 = 0;
           
       for(var i = 0;i < this.sortedData.length ;i++){
       
         if (r == 5) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID4 = totalHID4 + 1
               this.CalResponDaerah4 = totalHID4
           }
           }
       }
         return totalHID4;
     },
 
      calculateResponDaerah5(r,dp){
          
          var totalHID5 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
         
           if (r == 6) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID5 = totalHID5 + 1
               this.CalResponDaerah5 = totalHID5
           }
           }
       }
         return totalHID5;
     },
 
      calculateResponDaerah6(r,dp){
          
          var totalHID6 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
       
             if (r == 7) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID6 = totalHID6 + 1
               this.CalResponDaerah6 = totalHID6
           }
           }
       }
         return totalHID6;
     },
 
       calculateResponDaerah7(r,dp){
          
          var totalHID7 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
 
             if (r == 9) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID7 = totalHID7 + 1
               this.CalResponDaerah7 = totalHID7
           }
           }
       }
         return totalHID7;
     },
 
     calculateResponDaerah8(r,dp){
          
          var totalHID8 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
 
             if (r == 0) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID8 = totalHID8 + 1
               this.CalResponDaerah8 = totalHID8
           }
           }
       }
         return totalHID8;
     },
 
      calculateResponDaerah9(r,dp){
          
          var totalHID9 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
 
               if (r == 3) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID9 = totalHID9 + 1
               this.CalResponDaerah9 = totalHID9
           }
           }
       }
         return totalHID9;
     },
 
      calculateResponDaerah10(r,dp){
          
          var totalHID10 = 0;
                
       for(var i = 0;i < this.sortedData.length ;i++){
 
               if (r == 8) {
           if (this.sortedData[i].R == r && this.sortedData[i].DP == dp){
               totalHID10 = totalHID10 + 1
               this.CalResponDaerah10 = totalHID10
           }
           }
       }
         return totalHID10;
     },
 
       calculateResponDaerahSelesai(){
 
         var total = 0;
         let respon = 0;
        
           respon = total + Number(this.CalResponDaerah1) / Number(this.CalResponDaerahTotal) * 100;
           total = Number(respon);
           
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
           },
 
       calculateResponDaerahSelesaiSelain(){
          
          var total = 0;
         //  let respon = 0;
           var CalResponDaerah1 = 0;
           var CalResponDaerah2 = 0;
           var CalResponDaerah3 = 0;
           var CalResponDaerah4 = 0;
           var CalResponDaerah5 = 0;
           var CalResponDaerah6 = 0;
           var CalResponDaerah7 = 0;
           var CalResponDaerah8 = 0;
           var CalResponDaerah9 = 0;
           var CalResponDaerah10 = 0;
         
          
             for(var i = 0;i<this.sortedData.length;i++){
             if(this.CalResponDaerah1 == null){
               this.CalResponDaerah1 = 0;
             }
              if(this.CalResponDaerah2 == null){
               this.CalResponDaerah2 = 0;
             }
 
              if(this.CalResponDaerah3 == null){
               this.CalResponDaerah3 = 0;
             }
 
              if(this.CalResponDaerah4 == null){
               this.CalResponDaerah4 = 0;
             }
 
              if(this.CalResponDaerah5 == null){
               this.CalResponDaerah5 = 0;
             }
 
              if(this.CalResponDaerah6 == null){
               this.CalResponDaerah6 = 0;
             }
 
              if(this.CalResponDaerah7 == null){
               this.CalResponDaerah7 = 0;
             }
 
              if(this.CalResponDaerah8 == null){
               this.CalResponDaerah8 = 0;
             }
 
             if(this.CalResponDaerah9 == null){
               this.CalResponDaerah9 = 0;
             }
              if(this.CalResponDaerah10 == null){
               this.CalResponDaerah10 = 0;
             }
 
                total = total + (Number(this.CalResponDaerah1) + Number(this.CalResponDaerah2) + Number(this.CalResponDaerah3) + Number(this.CalResponDaerah4) + Number(this.CalResponDaerah5) + 
           Number(this.CalResponDaerah6) + Number(this.CalResponDaerah7) + Number(this.CalResponDaerah8)) / Number(this.CalResponDaerahTotal) * 100;
 
           this.CalResponDaerah1 = CalResponDaerah1;
           this.CalResponDaerah2 = CalResponDaerah2;
           this.CalResponDaerah3 = CalResponDaerah3;
           this.CalResponDaerah4 = CalResponDaerah4;
           this.CalResponDaerah5 = CalResponDaerah5;
           this.CalResponDaerah6 = CalResponDaerah6;
           this.CalResponDaerah7 = CalResponDaerah7;
           this.CalResponDaerah8 = CalResponDaerah8;
           this.CalResponDaerah9 = CalResponDaerah9;
           this.CalResponDaerah10 = CalResponDaerah10;
 
           total = Number(total);
 
           if(isNaN(total)) {          
                     return "0"
                   }
                   else {
 
           return total.toFixed(2);
                   }
             }
           },
 
     async permulaan() {
       this.peranan = this.$store.state.localStorageuser.role;
       this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
       let negeri = await negerilookup.getNegeri();
       let role = ["PP", "PO", "FE", "RESPONDENT"];
       this.disablenegeri = role.includes(this.peranan) === true ? true : false;
       this.disablesample = role.includes(this.peranan) !== true ? true : false;
       const Negeri = [];
       negeri.data.data.forEach(async function (element) {
         if (element.negeri !== "Admin" && element.negeri !== "Responden") {
           Negeri.push({
             negeriID: `${element.negeriID}`,
             negeri: `${element.negeri}`,
           });
         }
       });
       this.lookupnegeri = Negeri;
     
       for(var i =0;i<this.lookupnegeri.length;i++){
         if(this.lookupnegeri[i].negeriID == this.paparnegeriexport){
           this.detailNegeri = this.lookupnegeri[i];
         }
       }
 
     },
 
     async paparlookupsample() {
       this.negeri = this.paparnegeriexport.negeri;
       this.disablesample = false;
       this.paparsample = "";
       this.paparpusinganexport = "";
     
     },
   },
     watch:{
     paparnegeriexport(val){ 
       this.detailNegeri = val; 
     },
      // detailNegeri(){
      //  this.lookupDaerah();
      //  }
   }
 };
 </script>
 <style scoped id ="table_style" type="text/css">
 table {
   width: 100%;
   border-collapse: collapse;
   margin: 50px auto;
 }
 /* tr {
   background: #eee;
 } */
 
 td,
 th {
   padding: 10px;
   border: 1px solid #ccc;
   text-align: left;
   font-size: 18px;
 }
 </style>